module.exports = __webpack_public_path__ + "img/down.3a9ff520.png";